import { jwtDecode as decode } from 'jwt-decode';

const ADMIN_GROUPS = new Set(['tenant_admin', 'admin']);

const normalizeGroups = (groups) => {
  if (Array.isArray(groups)) {
    return groups.filter(Boolean).map((item) => String(item));
  }
  if (typeof groups === 'string' && groups) {
    return [groups];
  }
  return [];
};

const extractPrincipalFromToken = (token) => {
  if (!token) {
    return null;
  }

  try {
    const payload = decode(token);
    const groups = normalizeGroups(payload['cognito:groups'] || payload.groups);
    const role = String(payload['custom:role'] || payload.role || '').trim().toLowerCase();

    return {
      subject: String(payload.sub || ''),
      username: String(payload['cognito:username'] || payload.email || payload.username || payload.sub || ''),
      role,
      tenantId: payload['custom:tenant_id'] || payload.tenant_id || null,
      groups,
      isAdmin: role === 'admin' || role === 'tenant_admin' || groups.some((group) => ADMIN_GROUPS.has(group)),
      expiresAt: payload.exp || null,
    };
  } catch {
    return null;
  }
};

export { extractPrincipalFromToken };
